module.exports = __webpack_public_path__ + "static/img/weibo.e61bb19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weibo.png
// module id = YH5a
// module chunks = 0